// import './Board.css'
// import { useEffect, useLayoutEffect, useState } from 'react';
// import { StickyNote } from './StickyNote.js'
// import NoteForm from './NoteForm.js';
// import { Box } from '@mui/material';

// const RenderData = ({ data, settings, groupNameArr, releaseNameArr }) => {
//   const renderEmpty = () => <div className='emptyNote'></div>;
//   const renderNoteArray = noteArray => (
//     <div>
//       {
//         noteArray.map(note => (
//           <StickyNote note={note} settings={settings} />
//         ))
//       }
//     </div>
//   );
//   const renderNoteGroupArray = (name, groups) => (
//     <div className="display-flex">
//       {
//         groups.map(group => (
//           <div>
//             <StickyNote
//               note={group}
//               settings={settings} />
//             <RenderData
//               data={group}
//               settings={settings}
//               groupNameArr={groupNameArr}
//               releaseNameArr={releaseNameArr} />
//           </div>
//         ))
//       }
//     </div>
//   );

//   if (data == null) {
//     return renderEmpty();
//   }

//   return Object.entries(data).sort().map(([key, value]) => {
//     if (value === null) {
//       return renderEmpty();
//     }
//     if (["tags"].includes(key)) {
//       return <></>;
//     }
//     if (Array.isArray(value) && releaseNameArr && releaseNameArr.includes(key)) {
//       return renderNoteArray(value);
//     }
//     if (Array.isArray(value) && groupNameArr && groupNameArr.includes(key)) {
//       return renderNoteGroupArray(key, value);
//     }
//   });
// };

// export function Board({ data, settings, onDataChanged }) {
//   const groupNameArr = settings.types.groups.map(e => e.name);
//   const releaseNameArr = settings.types.releases.map(e => e.name);

//   return (
//     <div className="padding-base">
//       <div className="display-flex">
//         <RenderData
//           data={data}
//           settings={settings}
//           groupNameArr={groupNameArr}
//           releaseNameArr={releaseNameArr}
//         />
//       </div>
//     </div>
//   );
// }

// export default Board;

import "./Board.css";
import { useEffect, useLayoutEffect, useState } from "react";
import { StickyNote } from "./StickyNote.js";
import NoteForm from "./NoteForm.js";
import { Box } from "@mui/material";
import { UserStory, UserStoryGroup } from "./UserStory2.js";

export function Board({ data, settings, onDataChanged }) {
  const RenderData = ({ data, settings, showLabel }) => {
    const renderBackbone = (group, index) => (
      <div>
        {showLabel && index == 0 && (
          <div className="slice">
            <div className="slice-label">{settings.getGroupLabel(group)}</div>
          </div>
        )}
        <StickyNote
          group={group}
          userStory={group.userStory}
          settings={settings}
        />
        <div className={group.hasBackbone() ? "display-flex backbones" : ""}>
          <RenderData
            data={group.groupItems}
            settings={settings}
            showLabel={showLabel && index == 0}
          />
        </div>
      </div>
    );
    const renderSlice = (group, i) => (
      <div className="display-flex flex-wrap slices">
        {group.groupItems.map((userStory, index) => (
          <>
            {showLabel && index == 0 && (
              <div className="slice">
                <div className="slice-label">
                  {settings.getGroupLabel(group)}
                </div>
              </div>
            )}
            <StickyNote
              group={group}
              userStory={userStory}
              settings={settings}
            />
          </>
        ))}
      </div>
    );
    const renderEmpty = () => <div className="emptyNote"></div>;

    return data.map((item, index) => {
      if (item == null) {
        return renderEmpty();
      }
      if (item instanceof UserStoryGroup) {
        if (item.isBackbone()) {
          return renderBackbone(item, index);
        }
        if (item.isSlice()) {
          return renderSlice(item);
        }
      }
    });
  };

  const RenderLabels = ({ data, settings }) => {
    return <RenderData data={data} settings={settings} showLabel={true} />;
  };

  // const RenderLabels = ({ data }) => {
  //   const items = data;
  //   const empty = () => <div>EMPTY</div>;
  //   const renderBackbone = (group) => (
  //     <div>
  //       <div className="tmpNote">{group.groupName}</div>
  //       <RenderLabels data={group.groupItems} />
  //     </div>
  //   );
  //   const renderSlice = (group) => (
  //     <div>
  //       {group.groupItems.map((e, i) => (
  //         <div className="tmpNote">{group.groupName}</div>
  //       ))}
  //     </div>
  //   );
  //   const render = () => {
  //     return items.map((item, i) => {
  //       if (item == null) return empty;
  //       if (item instanceof UserStoryGroup) {
  //         if (item.isBackbone()) {
  //           return i == 0 ? renderBackbone(item) : null;
  //         }
  //         if (item.isSlice()) {
  //           return renderSlice(item);
  //         }
  //       }
  //     });
  //   };
  //   return render();
  // };

  return (
    <div className="padding-base">
      <div className="board display-flex">
        {/* <RenderLabels data={data} /> */}
        <RenderData data={data} settings={settings} showLabel={true} />
      </div>
    </div>
  );
}

export default Board;
